import { render, staticRenderFns } from "./ItemForm.vue?vue&type=template&id=422a02b1&scoped=true&"
import script from "./ItemForm.vue?vue&type=script&lang=js&"
export * from "./ItemForm.vue?vue&type=script&lang=js&"
import style0 from "./ItemForm.vue?vue&type=style&index=0&id=422a02b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422a02b1",
  null
  
)

export default component.exports